import { deriveFullAddressFromPropertyKeys } from "../utils";
import { ADDRESS_MAX_LENGTH, MAX_LIST_SALE_PRICE } from "../constants";
import { parseSaleDateLocal } from "./saleDateInputUtils";
import { validateBedsFullHalfForm } from "../bedBathsUtils";

function parseNumberValue(v) {
  return Number(String(v).replace(/,/g, ""));
}

function isBlank(v) {
  return v === undefined || v === null || String(v).trim() === "";
}

export function getSaleDateMaxForInput() {
  const d = new Date();
  d.setDate(d.getDate() + 15);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function validateSinglePropertyForm(data) {
  const errors = {};
  const req = (name, label) => {
    const v = data[name];
    if (isBlank(v)) {
      errors[name] = `${label} is required`;
    }
  };
  req("status", "Status");
  if (isBlank(data.propertyType) && isBlank(data.customPropertyType)) {
    errors.propertyType = "Property Type is required";
  }
  // streetNumber, streetDirPrefix, streetSuffix are optional — agent may leave blank
  req("streetName", "Street Name");
  // listPrice and daysOnMarket are optional for Coming Soon status. May times agents dont have these values.

  if (data.status !== "Coming Soon") {
    req("listPrice", "List Price");
    req("daysOnMarket", "Days on Market");
  }
  // beds / fullBath / halfBath: validateBedsFullHalfForm (max 99 each)
  req("livingSqft", "Living SqFt");

  if (data.status === "Sold") {
    if (isBlank(data.saleDate)) {
      errors.saleDate = "Sale Date is required for Sold status";
    }
    if (isBlank(data.salePrice)) {
      errors.salePrice = "Sale Price is required for Sold status";
    }
  }

  // Sale Date cannot be later than Today + 15 days
  if (!isBlank(data.saleDate)) {
    const chosen = parseSaleDateLocal(data.saleDate);
    const maxDay = parseSaleDateLocal(getSaleDateMaxForInput());
    if (chosen && maxDay) {
      chosen.setHours(0, 0, 0, 0);
      maxDay.setHours(0, 0, 0, 0);
      if (chosen.getTime() > maxDay.getTime()) {
        errors.saleDate = "Sale Date cannot be more than 15 days in the future";
      }
    }
  }

  const fullAddress = deriveFullAddressFromPropertyKeys({
    streetDirPrefix: data.streetDirPrefix,
    streetNumber: data.streetNumber,
    streetName: data.streetName,
    streetSuffix: data.streetSuffix,
  });
  if (fullAddress.length > ADDRESS_MAX_LENGTH) {
    errors.addressCombined = `You have used ${fullAddress.length} characters out of ${ADDRESS_MAX_LENGTH} maximum allowed characters.`;
  }

  Object.assign(errors, validateBedsFullHalfForm(data));

  const integerFields = [
    ...(data.status !== "Coming Soon" ? [{ key: "listPrice", label: "List Price" }] : []),
    { key: "daysOnMarket", label: "Days on Market" },
    { key: "livingSqft", label: "Living SqFt" },
  ];
  integerFields.forEach(({ key, label }) => {
    const v = data[key];
    if (v !== undefined && v !== null && String(v).trim() !== "") {
      const n = parseNumberValue(v);
      if (!Number.isInteger(n) || n < 0) {
        errors[key] = `${label} must be a whole number`;
      }
    }
  });

  // Days on Market should not exceed 9999
  if (!isBlank(data.daysOnMarket)) {
    const dom = parseNumberValue(data.daysOnMarket);
    if (Number.isInteger(dom) && dom > 9999) {
      errors.daysOnMarket = "Days on Market cannot exceed 9,999";
    }
  }

  // List/Sale price: $100,000 minimum, $999,000,000 maximum
  if (data.status !== "Coming Soon" && !isBlank(data.listPrice)) {
    const listPrice = parseNumberValue(data.listPrice);
    if (!Number.isNaN(listPrice)) {
      if (listPrice < 100000) {
        errors.listPrice = "List Price must be at least $100,000";
      } else if (listPrice > MAX_LIST_SALE_PRICE) {
        errors.listPrice = "List Price cannot exceed $999,000,000";
      }
    }
  }
  if (!isBlank(data.salePrice)) {
    const salePrice = parseNumberValue(data.salePrice);
    if (!Number.isNaN(salePrice)) {
      if (salePrice < 100000) {
        errors.salePrice = "Sale Price must be at least $100,000";
      } else if (salePrice > MAX_LIST_SALE_PRICE) {
        errors.salePrice = "Sale Price cannot exceed $999,000,000";
      }
    }
  }
  // Living SqFt should be less than 100,000
  if (!isBlank(data.livingSqft)) {
    const sqft = parseNumberValue(data.livingSqft);
    if (Number.isInteger(sqft) && sqft >= 100000) {
      errors.livingSqft = "Living SqFt must be less than 100,000";
    }
  }

  return errors;
}
